'use strict';
import React from 'react';
import { Link } from 'react-router-dom';
import EmpCard from './empCard';


class EmployeeBody extends React.Component {
    constructor(props) {
        super(props);

    }

    render() {
        let employeeList;
        if (this.props.staffs) {
            employeeList = this.props.staffs.map((staff, index) => {
                return (<EmpCard staff={staff} key={index} history={this.props.history} />)
            });
        }
        return (
            <div className="atd-bd-wp">
                <div className="atd-em-lt">
                    {employeeList}
                </div>
            </div>
        );
    }
}
export default EmployeeBody;


// WEBPACK FOOTER //
// ./app/components/employeeComponents/employeeBody.js